<template>
    <div class="d-flex sub-nav">
        <property-tenure-select class="mr-1 mr-md-4" v-if="displayTenureDropdown"></property-tenure-select>
        <scrollable-widget
            arrow-bg-color="var(--secondary)"
            arrow-fg-color="var(--gray-dark)"
            :class="['nav-items d-none d-sm-flex']"
        >
            <b-navbar v-if="hasAccess">
                <b-navbar-nav>
                    <b-nav-item
                        v-for="(item, key) in subNav"
                        :key="`asset-nav-${key}`"
                        :to="item.route"
                        exact
                        exact-active-class="active"
                    >
                        {{ item.label }}
                    </b-nav-item>
                </b-navbar-nav>
            </b-navbar>
        </scrollable-widget>
        <b-navbar v-if="hasAccess" class="d-sm-none flex-grow-1 pr-0">
            <b-navbar-nav class="w-100 justify-content-between">
                <div class="d-flex justify-content-between">
                    <b-nav-item-dropdown no-caret>
                        <template #button-content>
                            <font-awesome-icon
                                :icon="['far', 'bars']"
                                size="lg"
                                class="text-dark"
                            >
                            </font-awesome-icon>
                        </template>
                    </b-nav-item-dropdown>
                    <b-nav-text class="ml-2 py-1 px-1 text-dark">{{ activeLink }}</b-nav-text>
                </div>
                <b-nav-item
                    href="#"
                    @click.prevent="onSearchClick"
                    :active="showSearch"
                >
                    <font-awesome-icon :icon="['fal', 'search']"/>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
        <b-navbar v-if="hasAccess" class="ml-auto py-1 px-3" ref="actionsMenu">
            <portal-target name="actions-subnav"/>
        </b-navbar>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import StatusCounter from '@/components/Action/StatusCounter';
import ActionStatus from '@/services/Action/ActionStatus';
import ScrollableWidget from '@/components/Widgets/ScrollableWidget';
import AssessmentTypeSelect from '@/components/Nav/AssessmentTypeSelect';
import PropertyTenureSelect from '@/components/Nav/PropertyTenureSelect';
import ActionsMenuVisibilityMixin from '@/components/Nav/ActionsMenuVisibilityMixin';

export default {
  name: 'Assets-Navbar',
  components: {
    StatusCounter,
    ScrollableWidget,
    AssessmentTypeSelect,
    PropertyTenureSelect,
  },
  mixins: [ActionsMenuVisibilityMixin],
  data() {
    return {
      showAnalysis: false,
      subNav: [
        {
          label: 'Inventory',
          route: {name: 'assetsProperties'},
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      showSearch: 'actionShowSearch',
      actionsMenuVisible: 'actionsMenuVisible',
    }),
    hasAccess() {
      return true;
    },
    activeLink() {
      const routeName = this.$route.name;
      const routeParams = this.$route.params;

      const activeRoute = this.subNav.find(item => {
        if (item.route.name === routeName) {
          if (routeName === 'actionStatus') {
            return item.route.params.statusFilter === routeParams.statusFilter;
          }

          return true;
        }

        return false;
      });

      return activeRoute ? activeRoute.label : null;
    },
    displayTenureDropdown() {
      return ['Assets'].includes(this.$route.meta.title);
    }
  },
  methods: {
    ...mapActions({onSearchClick: 'searchActionClicked'}),
  },
  mounted() {
    if (this.hasAccess) {
      
    }
  },
};
</script>
